import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setIsRedirectFromNotification } from "../MyPlanDetails/MyPlanDetails.slice";
import ActionCardDialogsContext from "./Context";

function ActionCardHelper() {
  const formStatus: any = useAppSelector((state) => state?.formDetails?.updateMyPlanCardDetail.status);
  const dispatch = useAppDispatch();
  const { setIsOpenViewActionDialog, setIsOpenEditActionDialog, setIsOpenAssigneeDialog } =
    React.useContext(ActionCardDialogsContext);
  const param = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const redirectToSecId = () => {
    const id = param?.id;
    const cardId = param?.cardId;
    const segments = location?.pathname?.split("/");
    const path = segments?.[1];
    if (cardId) navigate(`/${path}/${id}`, { replace: true });
  };

  useEffect(() => {
    if (formStatus === "success") {
      dispatch(setIsRedirectFromNotification(false));
      setIsOpenViewActionDialog(false);
      setIsOpenEditActionDialog(false);
      setIsOpenAssigneeDialog(false);
      redirectToSecId();
    }
  }, [formStatus]);
  return <></>;
}

export default ActionCardHelper;
